export const stringToBase64 = (plainText: string): string => {
    if (typeof window === 'undefined') {
      return Buffer.from(plainText).toString('base64');
    }
    return window.btoa(plainText);
  };